import axios from "axios";
import AxiosClient from "../../../services/axios.services";
class TrainingAssistanceServices {
  getTrainingAssistance = (params) =>
    AxiosClient.get("/api/app/capacitacion_asistencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getTrainingAssistanceById = (id) =>
    AxiosClient.get(`/api/app/capacitacion_asistencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveTrainingAssistance = (data) =>
    AxiosClient.post("/api/app/capacitacion_asistencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editTrainingAssistance = (id, data) =>
    AxiosClient.put(`/api/app/capacitacion_asistencia/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteTrainingAssistance = (id) =>
    AxiosClient.delete(`/api/app/capacitacion_asistencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  sendNotifications = (data) =>
    AxiosClient.post("api/app/correo_capacitaciones/", data, {
      headers: { "Content-Type": "application/json" },
    });
  sendNotificationsButton = (data) =>
    AxiosClient.post("api/app/envio_correos_convocatoria_asistencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  sendCorreoFacilitador = (data) =>
    AxiosClient.post("api/app/api_envio_correo_facilitador/", data, {
      headers: { "Content-Type": "application/json" },
    });
  saveAsistanceMassiveUpload = (data) =>
    AxiosClient.post("/api/app/carga_masiva_convocados_excel/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new TrainingAssistanceServices();
